/* Skeleton.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Hide, media, Show } from '@atlaskit/primitives/responsive';
import { HeaderSkeleton, Skeleton, Stripe } from '@atlassian/mpac-primitives';
import React from 'react';
import { SectionHeader } from './RegularSection';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _5 = "@media (min-width:48rem){._1xlo19bv{height:10px}._15flze3t{margin-top:var(--ds-space-0,0)}}";
const _4 = "._19pkxy5q{margin-top:var(--ds-space-400,2pc)}";
const _3 = "._4t3iftgi{height:8px}";
const _2 = "._1bsb1lit{width:10pc}";
const _ = "._2rkoiti9{border-radius:var(--ds-border-radius-100,4px)}";
export const ExploreMoreLinkSkeleton = forwardRef((_ref, __cmplr) => {
  let {
      as: C = Skeleton,
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_2rkoiti9 _1bsb1lit _4t3iftgi _19pkxy5q _1xlo19bv _15flze3t", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ExploreMoreLinkSkeleton.displayName = 'ExploreMoreLinkSkeleton';
}
export const RegularSectionSkeleton = _ref2 => {
  let {
    children,
    hideDescription,
    hideShowMore
  } = _ref2;
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsxs(SectionHeader, {
      children: [hideDescription ? /*#__PURE__*/_jsx(Stripe, {
        height: "1rem",
        width: "40%"
      }) : /*#__PURE__*/_jsx(HeaderSkeleton, {}), !hideShowMore && /*#__PURE__*/_jsx(Show, {
        above: "sm",
        children: /*#__PURE__*/_jsx(ExploreMoreLinkSkeleton, {})
      })]
    }), /*#__PURE__*/_jsx("div", {
      children: children
    }), !hideShowMore && /*#__PURE__*/_jsx(Hide, {
      above: "sm",
      children: /*#__PURE__*/_jsx(ExploreMoreLinkSkeleton, {})
    })]
  });
};